import React, { useState } from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import { RecipesCategories } from "./RecipesCategories/RecipesCategories";
import RecipesList from "./RecipesList/RecipesList";
import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";
import { useQuery } from "@apollo/react-hooks";
import { ALL_RECIPES, RECIPES } from "../../queries/recipesQuery";

import "./Recipes.scss";

const Recipes = (props) => {
  const [categoryIds, setCategoryIds] = useState(0);

  const changeCategory = (ids) => {
    setCategoryIds(ids);
  };

  const isFiltered = categoryIds !== 0;
  const limit = props.limit || 20;

  const { data: allData, loading: allLoading, fetchMore: allFetchMore } = useQuery(ALL_RECIPES, {
    variables: { limit },
    skip: isFiltered,
  });

  const { data: filteredData, loading: filteredLoading, fetchMore: filteredFetchMore } = useQuery(RECIPES, {
    variables: { limit, categoryIds: [String(categoryIds)] },
    skip: !isFiltered,
  });

  const loading = isFiltered ? filteredLoading : allLoading;
  const data = isFiltered ? filteredData : allData;
  const fetchMore = isFiltered ? filteredFetchMore : allFetchMore;

  const posts = data?.posts?.nodes || [];
  const hasNextPage = data?.posts?.pageInfo?.hasNextPage || false;
  const endCursor = data?.posts?.pageInfo?.endCursor;

  const loadMore = () => {
    fetchMore({
      variables: { limit, after: endCursor, ...(isFiltered ? { categoryIds: [String(categoryIds)] } : {}) },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          posts: {
            ...fetchMoreResult.posts,
            nodes: [...prev.posts.nodes, ...fetchMoreResult.posts.nodes],
          },
        };
      },
    });
  };

  if (loading) return <div></div>;

  return (
    <Container>
      {!props.home && !props.singleProduct && (
        <div className="categories_container">
          <RecipesCategories
            recipes={true}
            handleCategoryChange={changeCategory}
            categoryIds={categoryIds}
          />
        </div>
      )}

      <h5 className={props.home ? "recipes_title home" : "recipes_title"}>
        Receta
      </h5>

      {props.showTitle && (
        <p className="single-product-title">
          Receta të ngashme për këtë produkt
        </p>
      )}

      <RecipesList data={posts} />
      {!props.limit && hasNextPage && (
        <LoadMoreButton loadMore={loadMore} title={"Më shumë"} />
      )}

      {posts.length <= 0 && (
        <p className="no-recipes-message">Nuk ka receta per kete kategori!</p>
      )}

      {props.home && (
        <div id="button_containeer" className="button_container">
          <Link to="/recetat" className="btn btn-outline load-more-button">
            Më shumë
          </Link>
        </div>
      )}
    </Container>
  );
};

export default Recipes;
